var map = {
	"./Avalanche.png": 873,
	"./Blackhawks.png": 874,
	"./Blue Jackets.png": 875,
	"./Blues.png": 876,
	"./Bruins.png": 877,
	"./Canadiens.png": 878,
	"./Canucks.png": 879,
	"./Capitals.png": 880,
	"./Coyotes.png": 881,
	"./Devils.png": 882,
	"./Ducks.png": 883,
	"./Flames.png": 884,
	"./Flyers.png": 885,
	"./Golden Knights.png": 886,
	"./Hurricanes.png": 887,
	"./Islanders.png": 888,
	"./Jets.png": 889,
	"./Kings.png": 890,
	"./Kraken.png": 891,
	"./Leafs.png": 892,
	"./Lightning.png": 893,
	"./Maple Leafs.png": 894,
	"./Oilers.png": 895,
	"./Panthers.png": 896,
	"./Penguins.png": 897,
	"./Predators.png": 898,
	"./Rangers.png": 899,
	"./Red Wings.png": 900,
	"./Sabres.png": 901,
	"./Senators.png": 902,
	"./Sharks.png": 903,
	"./Stars.png": 904,
	"./Wild.png": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;